import { Link, NavLink } from "react-router-dom";
import { Clock3, Instagram, MessageCircle, Phone } from "lucide-react";
import { FACEBOOK, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK } from "../lib/constants";
import { useAppointment } from "../context/AppointmentContext";
import CERTIFICATE_URL from "../assets/carti.svg";
import FacebookIcon from "../assets/facebook.svg";
import logo from "../assets/headerlogo.png";
import whatsapp from "../assets/whatsapplogo.svg";

export default function Navbar() {
  const { openAppointment } = useAppointment();

  return (
    <header className="fixed inset-x-0 top-0 z-50 hidden bg-white shadow-[0_1px_0_rgba(10,31,102,0.08)] [--site-edge:24px] lg:block lg:[--site-edge:40px] xl:[--site-edge:130px]" data-testid="site-navbar">
      <div className="bg-[#06386f] text-white">
        <div className="flex h-[64px] w-full items-center justify-between gap-5 px-[var(--site-edge)] text-[12px] font-semibold lg:text-[13px] xl:text-[14px]">
          <div className="flex min-w-0 items-center gap-1 text-[13px] lg:text-[14px] xl:text-[16px]">
            <img src={CERTIFICATE_URL} alt="Certificate" className="h-6 w-6" />
            <span className="truncate">10+ YEARS OF CLINICAL EXCELLENCE IN JAMAICA</span>
          </div>
          <div className="flex shrink-0 items-center gap-3 xl:gap-4">
            <a href={`tel:${PHONE_TEL}`} className="inline-flex items-center gap-2 whitespace-nowrap">
              <Phone className="h-4 w-4" />
              {PHONE_DISPLAY}
            </a>
            <span className="h-4 w-px bg-white/55" />
            <span className="inline-flex items-center gap-2 whitespace-nowrap">
              <Clock3 className="h-4 w-4" />
              Mon-Fri 9AM-5PM | Every other Sat 9AM-12PM
            </span>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={FACEBOOK} target="_blank" rel="noreferrer" aria-label="Facebook">
              <img src={FacebookIcon} alt="Facebook" className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="flex h-[92px] w-full items-center justify-between gap-4 px-[var(--site-edge)]">
        <Link to="/" className="flex min-w-[248px] shrink-0 items-center gap-2 lg:gap-2.5 xl:min-w-[360px] 2xl:min-w-[430px]" data-testid="nav-logo-link">
          <img src={logo} alt="Be Dental Paradise" className="h-[50px] w-[50px] shrink-0 object-contain lg:h-[52px] lg:w-[52px] 2xl:h-[70px] 2xl:w-[70px]" />
          <div className="flex min-w-0 flex-col justify-center leading-none">
            <div className="whitespace-nowrap text-[24px] font-semibold text-[#071746] lg:text-[30px] xl:text-[34px] 2xl:text-[42px]">Be Dental Paradise</div>
            <div className="mt-1 whitespace-nowrap text-[12px] font-semibold uppercase text-[#0052ff] lg:text-[15px] xl:text-[17px] 2xl:text-[22px]">Beautiful smiles. Created here</div>
          </div>
        </Link>

        <nav className="flex min-w-0 shrink items-center justify-center gap-3 lg:gap-5 xl:gap-8 2xl:gap-12">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `relative whitespace-nowrap py-2 text-[13px] font-bold text-black transition-colors hover:text-[#0052ff] lg:text-[14px] xl:text-[16px] 2xl:text-[17px] ${
                  isActive ? "text-[#0052ff] after:absolute after:inset-x-0 after:-bottom-1 after:h-[3px] after:bg-[#0052ff]" : ""
                }`
              }
              data-testid={`nav-link-${link.label.toLowerCase()}`}
            >
              {link.label === "Services" ? "Service" : link.label}
            </NavLink>
          ))}
          <button
            type="button"
            onClick={openAppointment}
            className="relative whitespace-nowrap py-2 text-[13px] font-bold text-black transition-colors hover:text-[#0052ff] lg:text-[14px] xl:text-[16px] 2xl:text-[17px]"
            data-testid="nav-book-appointment"
          >
            Book Appointment
          </button>
        </nav>

        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-[58px] shrink-0 items-center justify-center gap-2 rounded-[10px] bg-[#079b65] px-4 text-[14px] font-extrabold leading-tight text-white transition hover:bg-[#078759] lg:h-[64px] lg:px-5 lg:text-[15px] xl:h-[70px] xl:gap-3 xl:px-6 xl:text-[16px] 2xl:px-7 2xl:text-[18px]"
          data-testid="nav-whatsapp-btn"
        >
          <img src={whatsapp} alt="WhatsApp" className="h-6 w-6" />
          <span className="whitespace-nowrap">Book on<br className="xl:hidden" /> WhatsApp</span>
        </a>
      </div>
    </header>
  );
}
